/**
 * User info segment containing notification, help, and user preview.
 *    Clicking the icons opens more detailed menus or redirects.
 */
import React, { Component } from 'react';
import AbEnvironment from '../auth/AbEnvironment'; 
import withStyles from '@mui/styles/withStyles';
import { Avatar, Button, Divider, Grid,
         Paper, Popover, Tooltip, Typography
} from '@mui/material';

import SystemMaintenanceAlert from './SystemMaintenanceAlert';

import UserInfoNotifications from './UserInfoNotifications';
import UserHelp from './UserHelp';
import AccountActivation from '../activation/AccountActivation';
import ConfirmationDialog from '../ui/ConfirmationDialog';
import { grey } from '@mui/material/colors';

const abEnvironment = new AbEnvironment();
const styleSheet = theme => ({
    avatar: {
      margin: 0,
      marginRight: 10,
      width: 34,
      height: 34,
      color: '#fff',
      fontSize: 16,
      backgroundColor: grey[500],
    },
    avatar2: {
        margin: 10,
        width: 40,
        height: 40,
        color: '#fff',
        fontSize: 16,
        backgroundColor: grey[500],
    },
    row: {
      display: 'flex',
      justifyContent: 'center',
      marginRight: 10,
    },
    paper: {
        width: '100%',
        overflow: 'auto',
    },
    popgrid: {
        paddingTop: 4,
        width: 220,
        marginBottom: 4,
    },
    popitem: {
      marginRight: 8,
    },
    popgrid2: {
      // padding: 8,
      width: 210,
      // marginBottom: 4,
    },
    popitem2: {
      marginTop: 8,
      marginBottom: 8
    },
    tooltipWidth: {
      maxWidth: 220,
      marginLeft: 10,
      fontSize: 10,
    }
  });

class UserInfoAvatar extends Component {
    state = {
        open: false,
        confirmMfa: false,
        anchorEl: null,
        anchorOriginVertical: 'bottom',
        anchorOriginHorizontal: 'center',
        transformOriginVertical: 'top',
        transformOriginHorizontal: 'center',
        mfa: abEnvironment.getUserAttribute("mfa"),
    };

    goTo(route) {
      this.props.history.push(`/${route}`);
      this.setState({
        open: false,
      });
    }
      
    handleChange = key => (event, value) => {
        this.setState({
          [key]: value,
        });
    };
    
    handleClickButton = () => {
        this.setState({
          open: true,
          anchorEl: this.wrapper.current,
        });
    };
    
    handleClose = () => {
        this.setState({
          open: false,
        });
    };

    activateMfa()
    {
      const { callPartnerApi, logout, logError } = this.props.auth;
      let theUrl = 'auth0/usermetadata/' + abEnvironment.getUserAttribute("u_auth0Uid");
      let payload = {
        'mfa': 'sms'
      }

      callPartnerApi(theUrl,
                     'PATCH',
                     payload)
      .then(resp => {
        // Logout
        logout();
      })
      .catch(err => {
        logError('Exception in UserInfoAvatar.js: ' + err);
      });
    }

    //wrapper for referencing dom node; replaces button
    wrapper = React.createRef();
    
    render() {
      const classes = this.props.classes;
      const {
        open,
        anchorEl,
        anchorOriginVertical,
        anchorOriginHorizontal,
        transformOriginVertical,
        transformOriginHorizontal,
      } = this.state;

      let justLogout = false;
      if (justLogout) {
        return (
          <div>
          <Button onClick={this.props.logout.bind(this)}>
            Logout
          </Button>
          </div>
        );
      }

      let uEmail = abEnvironment.getUserAttribute("u_email");
      if (uEmail == null || uEmail === '')
      {
        let expiresAt = JSON.stringify(new Date().getTime());
        localStorage.setItem('expires_at', expiresAt);
        this.props.logout.bind(this);
        return (
          <div>Not logged in </div>
        );
      }
      //removed this for now.  was creating a problem when the email did not really need to wrap.
      //for now it will scroll left to right for really long emails.
      /*if (uEmail.length > 28) {
        let twoLineEmail = uEmail.slice(0, uEmail.indexOf("@") + 1);
        twoLineEmail = twoLineEmail + '\n';
        twoLineEmail = twoLineEmail + uEmail.slice(uEmail.indexOf("@") + 1, uEmail.length);
        uEmail = twoLineEmail;
      }*/
      let userRole = Number(abEnvironment.getUserAttribute("u_userRole"));
      let changePasswordParms = 'passwordchange';

      let mfa = this.state.mfa;

      let mfaTooltipText =  `Multi-Factor Authentication (MFA) makes your account more secure by requiring
      more than one way of verifying your identity when you log in.  AppBind supports authentication apps for MFA.`;

      let accountStatus = abEnvironment.getUserAttribute("a_aStatus")

      return (
        <div className={classes.row}>
          <SystemMaintenanceAlert  auth={this.props.auth} history={this.props.history} />
          {this.props.auth.isAuthenticatedReseller() && !this.props.onCustomerStepper && accountStatus === "2" &&
            <AccountActivation history={this.props.history} />
          }
          {!this.props.auth.isAuthenticatedVendor() && !this.props.onCustomerStepper &&
            <UserHelp history={this.props.history} />
          }
          {!this.props.onCustomerStepper &&
            <UserInfoNotifications auth={this.props.auth} history={this.props.history} />
          }
          <Avatar 
            className={classes.avatar}
            ref={this.wrapper}
            onClick={this.handleClickButton}>
            {abEnvironment.getUserAttribute("u_inits")}
          </Avatar>
          <Popover
            open={open}
            anchorEl={anchorEl}
            onClose={this.handleClose}
            anchorOrigin={{
              vertical: anchorOriginVertical,
              horizontal: anchorOriginHorizontal,
            }}
            transformOrigin={{
              vertical: transformOriginVertical,
              horizontal: transformOriginHorizontal,
            }}
          >
          {/* */}
            <Paper className={classes.paper}>
              <div className={classes.row}>
                <Avatar className={classes.avatar2}>
                  {abEnvironment.getUserAttribute("u_inits")}
                </Avatar>

                <Grid container spacing={0} justifyContent="flex-start" className={classes.popgrid}>
                  <Grid item xs={12}>
                    <Typography >
                      {abEnvironment.getUserAttribute("a_accountName")}
                    </Typography>
                  </Grid>
                  <Grid item xs={12}>
                  <Typography data-recording-sensitive>
                    {abEnvironment.getUserAttribute("u_firstName") + " " + abEnvironment.getUserAttribute("u_lastName")}
                  </Typography>
                  </Grid>
                  <Grid item xs={12}>
                  <Typography variant="body2" data-recording-sensitive>
                    {uEmail}
                  </Typography>
                  </Grid>
                  { /* The following role designations will not
                        display - only values 0 and 1 make sense, but
                        we're deferring usage of that construct for now */ }
                  { userRole === 10 &&
                    <Typography>
                      Admin User
                    </Typography>
                  }
                  { userRole === 11 &&
                    <Typography>
                      User
                    </Typography>
                  }
                  
                  { !this.props.unAuthenticatedCustomer &&
                     <Grid item className={classes.popitem} style={{marginTop:'10px'}}>
                      <Typography><a target="_blank" rel="noopener noreferrer" href="http://www.appbind.com/terms">Terms</a></Typography>
                    </Grid>
                  }
                  { !this.props.unAuthenticatedCustomer &&
                    <Grid item className={classes.popitem} style={{marginTop:'10px'}}>
                      <Typography><a target="_blank" rel="noopener noreferrer" href="http://www.appbind.com/privacy">Privacy Policy</a></Typography>
                    </Grid>
                  }

                </Grid>
              </div>
            </Paper>
            { this.props.unAuthenticatedCustomer && abEnvironment.isMasquerade() &&
            <span>
              <Divider light/>
              <Paper className={classes.paper}>
                <div className={classes.row}>
                  <Button onClick={this.props.endMasquerade.bind(this)}>
                    Stop Masquerade
                  </Button>
                </div>
              </Paper>
            </span>
            }
            { !this.props.unAuthenticatedCustomer &&
            <span>
              <Divider light/>
              <Paper className={classes.paper}>
                <div className={classes.row}>
                  <ConfirmationDialog
                    open={this.state.confirmMfa}
                    onClose={() => { this.setState({confirmMfa:false});}}
                    onConfirm={() => { this.activateMfa() }}
                    onCancel={() => { }}
                    title="Enable Multi-Factor Authentication?"
                    cancelBtn="No"
                    okBtn="Yes, enable MFA and logout"
                  >
                    When you enable Multi-Factor Authentication (MFA), you will be logged out. 
                    When you log back into AppBind, you’ll be enrolled in SMS multi-factor authentication.
                  </ConfirmationDialog>
                  <Grid container spacing={0} alignItems="center" justifyContent="center" className={classes.popgrid2}>
                    {(mfa == null || mfa === 'none') &&
                    <Grid item xs={12}>
                      <Grid container alignItems="center" justifyContent="center" >
                      <Grid item>
                      <Tooltip id="tooltip-mfa" title={mfaTooltipText} 
                              classes={{tooltip: classes.tooltipWidth}} placement="bottom">
                      <Button style={{color: 'black'}} onClick={() => { this.setState({confirmMfa:true}); }}>
                              Enable MFA
                      </Button>
                      </Tooltip>
                      </Grid>
                      </Grid>
                    </Grid>
                    }
                    <Grid item xs={12}>
                      {/* mfa == null || mfa === 'none' &&
                      <Typography variant="body2">
                        MFA (Multi Factor Authentication) 
                        When you activate MFA, the next time you login you'll be asked to register an
                        authenticator app with AppBind.  Then, at each login, you'll
                        need to enter a one-time code from your authenticator app.
                      </Typography>
                  */}
                      {mfa != null && mfa !== 'none' &&
                      <Typography variant="body2" className={classes.popitem2}>
                        MFA (Multi-Factor Authentication) has been enabled.  To reset or 
                        disable MFA, please contact AppBind support.
                      </Typography>
                      }
                    </Grid>
                  </Grid>
                </div>
              </Paper>
              <Divider light/>
              <Paper className={classes.paper}>
                <div className={classes.row}>
                  {/* Note - the local goTo also closes the popup */}
                  { !abEnvironment.isMasquerade() &&
                  <Button style={{color: 'black'}} onClick={this.goTo.bind(this, changePasswordParms)}>
                    Change Password
                  </Button>
                  }
                  { abEnvironment.isMasquerade() &&
                  <Button style={{color: 'black'}} onClick={this.props.endMasquerade.bind(this)}>
                    Stop Masquerade
                  </Button>
                  }
                </div>
              </Paper>
            </span>
            }
            <Divider light/>
            <Paper className={classes.paper}>
              <div className={classes.row}>
                <Button style={{color: 'black'}} onClick={this.props.logout.bind(this)}>
                  Logout
                </Button>
              </div>
            </Paper>
          </Popover>
        </div>
      )
    }      
}
  
export default withStyles(styleSheet)(UserInfoAvatar);

/*
                <Grid container spacing={0} alignItems="center" justifyContent="center" className={classes.popgrid2}>
                  <Grid item xs={12}>
                    <Grid container justifyContent="center">
                    <Grid item>
                    <FormGroup>
                      <FormControlLabel
                        control={
                          <Switch
                            checked={this.state.mfa === "sms"}
                            onChange={(e, checked) => {
                              if (checked) {
                                this.setState({ mfa: "sms"});
                              } else {
                                this.setState({ mfa: "none"});
                              }
                            }}
                          />
                          }
                        label="Use MFA"
                      />
                    </FormGroup>
                    </Grid>
                    </Grid>
                    <ConfirmationDialog
                      open={this.state.confirmMfa}
                      onClose={() => { this.setState({confirmMfa:false});}}
                      onConfirm={() => { }}
                      onCancel={() => { }}
                      title="Setup MFA?"
                      cancelBtn="No"
                      okBtn="Yes, setup MFA"
                    >
                      Do you wish to proceed?
                    </ConfirmationDialog>
                  </Grid>
                  <Grid item xs={12}>
                    <Typography variant="body2">
                      When you activate MFA, the next time you login you'll be asked to provide
                      a mobile number that can receive SMS messages.  Then, at each login, you'll
                      need to enter a code that will be sent to your mobile device.
                    </Typography>
                  </Grid>
                </Grid>

*/